import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText, downloadFile } from "../../lib/api";
import { FilePdf, Receipt } from "@phosphor-icons/react";

export default function MyPayslips() {
  const [list, setList] = useState([]);
  const [fys, setFys] = useState([]);
  const [loans, setLoans] = useState([]);

  useEffect(() => {
    api.get("/payroll/payslips/me").then((r) => setList(r.data));
    api.get("/payroll/form16/years").then((r) => setFys(r.data)).catch(() => {});
    api.get("/payroll/loans/me").then((r) => setLoans(r.data.filter((l) => l.status === "active"))).catch(() => {});
  }, []);

  const dl = (s) => downloadFile(`/payroll/payslips/${s.id}/pdf`, `payslip_${s.month}.pdf`)
    .then(() => toast.success("Payslip downloaded"))
    .catch((e) => toast.error(errText(e)));

  const dlForm16 = (fy) => downloadFile(`/payroll/form16/${fy}/pdf`, `form16_${fy}.pdf`)
    .then(() => toast.success("Form 16 downloaded"))
    .catch((e) => toast.error(errText(e)));

  return (
    <div className="space-y-5" data-testid="my-payslips-page">
      <h1 className="font-heading text-2xl font-extrabold">My payslips</h1>

      {loans.length > 0 && (
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5" data-testid="my-loans-card">
          {loans.map((l) => (
            <div key={l.id} className="text-sm text-amber-900">
              <span className="font-bold">Salary advance:</span> ₹{l.outstanding.toLocaleString("en-IN")} outstanding
              <span className="text-amber-700"> · ₹{l.monthly_installment.toLocaleString("en-IN")}/month recovered from salary</span>
            </div>
          ))}
        </div>
      )}

      {fys.length > 0 && (
        <div className="bg-white border border-stone-200 rounded-2xl p-5" data-testid="form16-section">
          <h3 className="font-heading font-bold text-sm mb-3 flex items-center gap-2">
            <Receipt size={18} weight="duotone" className="text-secondary" /> Form 16 — annual tax summary
          </h3>
          <div className="flex flex-wrap gap-2">
            {fys.map((fy) => (
              <button key={fy} onClick={() => dlForm16(fy)} data-testid={`download-form16-${fy}`}
                className="tap-scale flex items-center gap-2 min-h-[40px] px-4 rounded-full bg-secondary text-white text-xs font-bold hover:bg-[#1E2B22] transition-colors duration-200">
                <FilePdf size={15} /> FY {fy}
              </button>
            ))}
          </div>
        </div>
      )}

      {list.length === 0 ? (
        <div className="bg-white border border-stone-200 rounded-2xl p-10 text-center">
          <FilePdf size={40} className="mx-auto text-stone-300" />
          <p className="text-sm text-stone-400 mt-3">No payslips yet. They appear here after payroll is processed.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {list.map((s) => (
            <div key={s.id} className="bg-white border border-stone-200 rounded-2xl p-5 flex items-center justify-between" data-testid={`payslip-card-${s.month}`}>
              <div>
                <div className="font-heading font-bold tabular-nums">{s.month}</div>
                <div className="text-xs text-stone-500 tabular-nums">
                  Net pay ₹{s.net_pay.toLocaleString("en-IN")}
                  {s.lop_days > 0 ? ` · ${s.lop_days} LOP day${s.lop_days > 1 ? "s" : ""}` : ""}
                  {s.ot_pay > 0 ? ` · ₹${s.ot_pay.toLocaleString("en-IN")} OT (${s.ot_hours}h)` : ""}
                  {s.reimbursements > 0 ? ` · ₹${s.reimbursements.toLocaleString("en-IN")} reimbursed` : ""}
                </div>
              </div>
              <button onClick={() => dl(s)} data-testid={`download-payslip-${s.month}`}
                className="tap-scale flex items-center gap-2 min-h-[44px] px-5 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200">
                <FilePdf size={18} /> PDF
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
